import { LayoutGrid, Rows3 } from "lucide-react";

export default function ViewToggle({ view, onChange }) {
  return (
    <div
      className="inline-flex items-center rounded-lg border border-border/60 bg-card p-0.5"
      data-testid="view-toggle"
    >
      <button
        type="button"
        onClick={() => onChange("kanban")}
        data-testid="view-toggle-kanban"
        className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
          view === "kanban"
            ? "bg-[hsl(var(--accent-navy))] text-white"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <LayoutGrid className="h-3.5 w-3.5" />
        Kanban
      </button>
      <button
        type="button"
        onClick={() => onChange("list")}
        data-testid="view-toggle-list"
        className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
          view === "list"
            ? "bg-[hsl(var(--accent-navy))] text-white"
            : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <Rows3 className="h-3.5 w-3.5" />
        Liste
      </button>
    </div>
  );
}
